const state= {
    Items: []
};

const getters = {
    Items : (state) => state.Items,
};

const actions = {
    getItems({commit},params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/master/brands`,{
                params: params
            })
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => {
                    reject( error )
                });
        });
    },
    createItem({commit},param){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/master/brands`,param)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => {
                    reject( error )
                });
        });
    },
    updateItem({commit},param){
        return new Promise (( resolve, reject ) => {
            global.axios.put(`api/master/brands/${param.id}`,param)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => {
                    reject( error )
                });
        });
    },
    deleteItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`api/master/brands`, {
                data:{
                    ids:params
                }
            })
                .then(response => {
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
};

const mutations = {
    setItems (state,data) {
        state.Items = data.items;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}